import axiosPrivateMl from "../axiosPrivateMl"

const verifyMagicOtp = async (didToken) => {
  try {
    const response = await axiosPrivateMl.post(
      "/verify_magic_login", // Just the endpoint path, no base URL
      {
        did_token: didToken,
      }
    )

    return response.data
  } catch (error) {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      console.error("Error verifying magic OTP:", error.response.data)
      throw error.response.data
    } else if (error.request) {
      // The request was made but no response was received
      console.error("No response received:", error.request)
      throw new Error("No response from server")
    } else {
      // Something happened in setting up the request that triggered an Error
      console.error("Error:", error.message)
      throw error
    }
  }
}

export default verifyMagicOtp
